import { Box, Grid, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import { clientesApi } from "src/services/clientesApi";
import GenerarResumenEjecutivoButton from "src/components/propuesta/GenerarResumenEjecutivoButton";
import CampoTextoIA from "../components/CampoTextoIA";

// Convierte items V2 en el shape { titulo, objetivo, monto } que acepta generarResumenEjecutivo.
function mapearItemsAFases(items = []) {
  return items.map((it) => ({
    titulo: it.nombreServicio || it.faseTitulo || "Servicio sin título",
    objetivo: it.faseObjetivo || "",
    monto: it.valorConDescuento
      ? `${it.valorConDescuento} ${it.tipoMoneda}`
      : "",
  }));
}

// Suma los montos por moneda y devuelve un string consolidado multi-moneda.
function construirMontoTotalString(items = []) {
  const porMoneda = items.reduce((acc, it) => {
    if (!it.valorConDescuento || !it.tipoMoneda) return acc;
    acc[it.tipoMoneda] =
      (acc[it.tipoMoneda] || 0) + Number(it.valorConDescuento);
    return acc;
  }, {});
  return Object.entries(porMoneda)
    .map(([m, total]) => `${total} ${m}`)
    .join(" + ");
}

// Extrae clientes únicos referenciados por items, con lookup en listadoClientes.
// Retorna array de { nombre } sin razonSocial (columna que no existe en la tabla cliente).
// Si un refCliente no se encuentra en el listado o no tiene nombre, se omite.
function extraerClientesUnicos(items = [], listadoClientes = []) {
  const refsUnicos = [
    ...new Set(items.map((it) => it.refCliente).filter(Boolean)),
  ];
  return refsUnicos
    .map((rut) => {
      const c = listadoClientes.find((x) => x.rut === rut);
      return c?.nombre ? { nombre: c.nombre } : null;
    })
    .filter(Boolean);
}

const StepQuienesSomos = ({ formik }) => {
  const v = formik.values;

  const { data: listadoClientes = [] } = clientesApi.useGetClientesQuery({
    estado: "TODOS",
  });

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Quiénes Somos
      </Typography>
      <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
        Presenta a Taxtic y genera el resumen ejecutivo de la propuesta.
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <CampoTextoIA
            formik={formik}
            name="introduccion"
            label="Introducción de Taxtic"
            multiline
            minRows={5}
            helperText="Texto de presentación de la firma. Edita según el contexto del cliente."
            contextIA="Introducción institucional de Taxtic en una propuesta comercial tributaria."
          />
        </Grid>

        <Grid item xs={12} id="seccion-resumenEjecutivo">
          <CampoTextoIA
            formik={formik}
            name="resumenEjecutivo"
            label="Resumen Ejecutivo"
            multiline
            minRows={4}
            helperText="Síntesis de la propuesta orientada al cliente. Usa el botón IA para generarlo automáticamente."
            contextIA="Resumen ejecutivo de una propuesta comercial tributaria. Síntesis orientada al cliente."
            endActions={
              <GenerarResumenEjecutivoButton
                titulo={v.titulo}
                descripcion={v.descripcion}
                antecedentes={v.antecedentes}
                resumenEjecutivo={v.resumenEjecutivo}
                fases={mapearItemsAFases(v.items)}
                montoTotal={construirMontoTotalString(v.items)}
                duracionEstimada={v.duracionEstimada}
                clientes={extraerClientesUnicos(v.items, listadoClientes)}
                onGenerated={(resumen) =>
                  formik.setFieldValue("resumenEjecutivo", resumen)
                }
              />
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
};

StepQuienesSomos.propTypes = {
  formik: PropTypes.object.isRequired,
};

export default StepQuienesSomos;
